import { ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { YodleeQuery } from '@1bill-app/services/yodlee/yodlee.query';
import { YodleeService } from '@1bill-app/services/yodlee/yodlee.service';
import { YodleeStore } from '@1bill-app/services/yodlee/yodlee.store';
import { SpendingCategory } from '@1bill-app/services/yodlee/yodlee.types';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-net-income',
  templateUrl: './net-income.page.html',
  styleUrls: ['./net-income.page.scss'],
})
export class NetIncomePage implements OnInit {
  subs = new SubSink();
  selectedSegment: 'EXPENSE' | 'INCOME' = 'EXPENSE';
  
  /** Net income chart data and toolbar data */
  public netWealthDetailedChartData$ = this.yodleeQuery.netWealthDetailedChartData$;
  public currentDurationDate$ = this.yodleeQuery.netIncomeCurrentDurationDate$;
  public availableDurations$ = this.yodleeQuery.availableDurations$;
  public currentDuration$ = this.yodleeQuery.currentDuration$;
  public incomeCategories$ = this.yodleeQuery.currentIncomeCategories$;
  public expenseCategories$ = this.yodleeQuery.currentExpenseCategories$;

  defaultHref = ROUTE_HOMEPAGE;
  availableDurations: string[];

  constructor(
    private yodleeQuery: YodleeQuery,
    private yodleeService: YodleeService,
    private logger: NGXLogger,
    private yodleeStore: YodleeStore,
  ) {}

  fetchData() {
    this.subs.sink = this.yodleeService.getNetWealthData().subscribe();
  }

  intervalChanged(to: 'W' | 'M' | 'Y') {
    this.yodleeStore.update({ currentDuration: to });
    this.fetchData();
  }

  durationChanged(to: string) {
    this.yodleeStore.update({ netIncomeCurrentDurationDate: to });
    this.fetchData();
  }

  trackByFn(item) {
    return item.id;
  }

  async ngOnInit() {
    this.subs.sink = this.yodleeService.getNetWealthData().subscribe();
  }

  segmentChanged(event: any) {
    this.selectedSegment = event.target.value;
  }

  doRefresh(event: any) {
    // TODO: Refresh event
    event.target.complete();
  }
}
